import angular from 'angular';

export default function CAEditCustomerDirectiveController(
  $scope,
  $q,
  $timeout,
  userService,
  orgDataService,
  emDataService
) {
  const vm = this;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _initPermissions();
    $scope.$on(
      'refreshCustomer',
      ($event, refreshCustomerArgs) => {
        if (vm.customerId === refreshCustomerArgs.customerId) {
          _refresh().then(() => {
            $scope.$emit(`customer${vm.customer.customerId}Refreshed`);
          });
        }
      }
    );
    $scope.$emit('bankDirectiveEventsSet');
  }

  function _initPermissions() {
    userService.getUserPermissionSet('admin').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _refresh() {
    const dfdRefresh = $q.defer();
    const dfdGetCustomer = orgDataService.getCustomer(vm.customerId);
    const dfdGetCustomerServices = orgDataService.getCustomerServices(vm.customerId);
    const dfdGetDepartments = emDataService.getDepartments(vm.customerId);
    $q.all([
      dfdGetCustomer,
      dfdGetCustomerServices,
      dfdGetDepartments,
    ]).then((responses) => {
      let customerServices = [];
      if (responses[0]) {
        vm.customer = responses[0].data.result;
      } else {
        vm.customer = {
          customerId: -1,
        };
      }
      const dfdProcessServices = $q.defer();
      if (responses[1]) {
        customerServices = [];
        angular.forEach(
          vm.services,
          (masterService, masterServiceIndex) => {
            let isMatched = false;
            angular.forEach(
              responses[1].data.result.customerservices,
              (customerService) => {
                if (masterService.serviceId === customerService.serviceId) {
                  isMatched = true;
                  const combinedService = angular.extend(
                    {},
                    masterService,
                    customerService
                  );
                  combinedService.customerService = JSON.stringify(customerService);
                  customerServices.push(combinedService);
                }
              }
            );
            if (!isMatched) {
              customerServices.push(angular.extend(
                {},
                masterService
              ));
            }
            if (masterServiceIndex === vm.services.length - 1) {
              $timeout(
                dfdProcessServices.resolve,
                50
              );
              console.log('services processed');
            }
          }
        );
        vm.customerServices = customerServices;
      } else {
        vm.customerServices = null;
      }
      if (responses[2]) {
        vm.departments = responses[2].data.result;
      }

      dfdProcessServices.promise.then(dfdRefresh.resolve);
    });
    return dfdRefresh.promise;
  }
}

CAEditCustomerDirectiveController.$inject = [
  '$scope',
  '$q',
  '$timeout',
  'userService',
  'orgDataService',
  'emDataService'
];
